module.exports = __webpack_public_path__ + "img/iconOfflineOthers.d41a374e.png";